// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"7ae3a0e8","277":"b2b6574a"}[chunkId] + ".chunk.css";
};